<template>
  <div class="courseware-note-box">
    <h2>写笔记</h2>
    <div>
      <VQuillEditor
        :height="150"
        @change="getEditor"
        :value="contentHtml"
        placeholder="在此记录你的想法…"
      />

      <!-- <template v-if="distributeWay === '1'"> -->
      <div class="courseware-note-release">
        <div class="box-left">
          <a-checkbox v-model="form.isPublic">公开笔记</a-checkbox>
          <!-- <a-checkbox
            v-if="coursewareType === '3' || coursewareType === '4'"
            v-model="point"
            @change="pointHand"
            >添加驻点</a-checkbox
          >
          <PointTime :currentTime="currentTime" class="time" /> -->
        </div>
        <a-button
          class="btn-orange"
          shape="round"
          style="padding: 4px 12px"
          @click="submit"
          :loading="loading"
          >提交</a-button
        >
      </div>
      <!-- </template> -->

      <!-- <template v-else>
        <div class="courseware-note-release">
          <div>
            <a-checkbox v-model="form.isPublic">公开笔记</a-checkbox>
            <a-checkbox
              v-if="coursewareType === '3' || coursewareType === '4'"
              v-model="point"
              @change="pointHand"
              >添加驻点</a-checkbox
            >
          </div>
          <PointTime :currentTime="currentTime" />
        </div>
        <div style="text-align: right; margin-top: 12px">
          <a-button
            class="btn-orange"
            shape="round"
            style="padding: 4px 12px"
            @click="submit"
            :loading="loading"
            >提交</a-button
          >
        </div>
      </template> -->
    </div>

    <div class="select">
      <p>全部笔记</p>
      <div class="switch">
        <a-switch v-model="oneself" @change="oneselfHand" />
        <span>只看我的</span>
      </div>
    </div>
    <a-spin :spinning="spinning">
      <div v-if="noteList.length">
        <NoteBox
          class="box"
          v-for="el in noteList"
          :key="el.id"
          :info="el"
          @edit="noteEdit"
          @open="noteOpen"
          @del="noteDel"
          @changeTime="changeVideoTime"
        />
        <a-pagination
          hideOnSinglePage
          style="text-align: center; margin-top: 40px"
          :current="pagination.current"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @change="change"
        />
      </div>
      <div v-else>
        <a-empty description="暂时还没有笔记" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import VQuillEditor from "@/components/VQuillEditor.vue";
import PointTime from "./pointTime.vue";
import NoteBox from "./noteBox.vue";
import {
  getNotePageList,
  courseStudyNoteSave,
  studentNoteUploadPublic,
  studentNoteRemove,
} from "@/api/activity";
import { mapGetters } from "vuex";

export default {
  props: ["coursewareType", "currentTime"],
  components: {
    VQuillEditor,
    PointTime,
    NoteBox,
  },
  data() {
    return {
      loading: false,
      spinning: false,
      contentHtml: "",
      point: false,
      oneself: false,
      noteList: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      form: {
        content: "",
        isPublic: false,
        markTime: "",
        chapterContentId: "",
        courseStudyId: "",
      },
      noteParams: {
        chapterContentId: "",
        courseStudyId: "",
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    courseId: function () {
      return this.$route.query.courseId;
    },
  },
  mounted() {},
  methods: {
    loadList(courseStudyId, chapterContentId) {
      let page = {
        current: this.pagination.current,
        size: this.pagination.pageSize,
      };
      this.spinning = true;
      this.noteParams.courseStudyId = courseStudyId;
      this.noteParams.chapterContentId = chapterContentId;
      getNotePageList(page, this.noteParams).then((res) => {
        this.noteList = res.records;
        this.pagination.total = res.total;
        this.spinning = false;
      });
    },

    change(page, pageSize) {
      this.pagination.current = page;
      this.pagination.pageSize = pageSize;
      this.loadList(
        this.noteParams.courseStudyId,
        this.noteParams.chapterContentId
      );
    },

    init() {
      this.pagination.current = 1;
      this.loadList(
        this.noteParams.courseStudyId,
        this.noteParams.chapterContentId
      );
    },

    pointHand(e) {
      if (e.target.checked) {
        if (!this.currentTime) {
          this.$message.warning("请先暂停播放！");
          this.point = false;
        }
      }
    },

    submit() {
      if (!this.form.content) {
        this.$message.warning("请先输入笔记！");
        return;
      }
      this.loading = true;
      this.form.markTime = this.currentTime;
      this.form.chapterContentId = this.noteParams.chapterContentId;
      this.form.courseStudyId = this.noteParams.courseStudyId;
      courseStudyNoteSave(this.form).then(() => {
        this.$message.success("提交成功！");
        this.contentHtml = "";
        this.form.content = "";
        this.init();
        this.loading = false;
      });
    },

    oneselfHand(e) {
      if (!e) {
        this.noteParams.studentId = "";
        this.noteParams.studentIdOrIsPublic = this.userInfo.id;
      } else {
        this.noteParams.studentId == this.userInfo.id;
        this.noteParams.studentIdOrIsPublic = "";
      }
      this.init();
    },

    noteEdit(info) {
      this.form = { ...info };
      this.contentHtml = info.content;
      if (info.markTime) {
        this.changeVideoTime(info.markTime);
        this.point = true;
      }
    },

    async noteDel(info) {
      await studentNoteRemove(info.id);
      this.$message.success("删除成功！");
      this.init();
    },

    async noteOpen(info) {
      await studentNoteUploadPublic({ id: info.id });
      this.$message.success("操作成功！");
      this.init();
    },

    changeVideoTime(time) {
      this.$emit("changeTime", time);
    },

    getEditor(val) {
      this.form.content = val;
      this.contentHtml = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.courseware-note-box {
  padding: 20px 16px;
  h2 {
    font-weight: 600;
    font-size: 16px;
    color: #262626;
    line-height: 22px;
    margin-bottom: 24px;
  }
  .wangEditor-box {
    :deep(.wangEditor) {
      height: 150px;
    }
  }
  > div {
    padding-bottom: 32px;
    .courseware-note-release {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 16px;
      .box-left {
        display: flex;
        align-items: center;
        .time {
          margin-left: 16px;
        }
      }
      :deep(.ant-checkbox-group) {
        display: flex;
        align-items: flex-start;
        .ant-checkbox-wrapper {
          display: flex;
        }
      }
      > p {
        display: flex;
        align-items: center;
        margin-top: 2px;
        > span {
          border: 1px solid #dcdee0;
          border-left: 0;
          line-height: 14px;
          height: 16px;
          padding: 0 8px;
        }
      }
    }
  }
  .select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    > p {
      font-weight: 600;
      font-size: 16px;
      color: #262626;
      line-height: 22px;
    }
    .switch {
      display: flex;
      align-items: center;
      > span {
        font-weight: 400;
        font-size: 12px;
        color: #8c8c8c;
        line-height: 17px;
        margin-left: 12px;
      }
    }
  }
  .note-list {
    > .box:not(:first-child) {
      margin-bottom: 24px;
    }
  }
  .courseware-note-title {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
    line-height: 20px;
    margin: 24px 0 8px 0;
  }
}
</style>
